function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiveClubs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.87,
    height: 20.782,
    viewBox: "0 0 20.87 20.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6672",
    d: "M72.2 103.136c-1.935 0-3.44 2.078-3.583 3.87-.143 2.293.645 4.515 3.01 5.3a4.583 4.583 0 0 0 4.73-.932c.287-.287 1.147-1.863 1.5-1.863.287 0 1.147 1.577 1.433 1.863a4.582 4.582 0 0 0 4.73.932c2.365-.788 3.153-3.01 3.01-5.3-.143-1.792-1.648-3.87-3.583-3.87h-.788a1.062 1.062 0 0 0-.86-.788H73.92a1.062 1.062 0 0 0-.932.788zm0 .5c-1.648 0-2.938 1.863-3.082 3.44-.143 2.078.573 4.085 2.652 4.8a4.3 4.3 0 0 0 4.228-.86c.5-.573 1.075-2.007 1.863-2.007.717 0 1.29 1.433 1.792 2.007a4.3 4.3 0 0 0 4.228.86c2.078-.717 2.795-2.723 2.652-4.8-.143-1.577-1.433-3.44-3.082-3.44z",
    transform: "translate(-68.601 -98.55)",
    style: {
      fill: "#aeaeae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6673",
    d: "M103.53 154.48h11.252c1.075 0 2.293 1.362 2.437 2.867.358 4.873-4.371 4.945-5.733 3.44-.788-.86-1.075-2.222-2.293-2.222s-1.577 1.362-2.365 2.222c-1.362 1.5-6.091 1.433-5.661-3.44.072-1.5 1.29-2.867 2.365-2.867z",
    transform: "translate(-99.931 -148.747)",
    style: {
      fill: "#aeaeae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6674",
    d: "M251.836 13.539h2.864a1.256 1.256 0 0 1 1.218 1.218A1.194 1.194 0 0 1 254.7 15.9h-.143a3.086 3.086 0 0 0 1.935 2.15 4.2 4.2 0 0 0 1.648.287 3.221 3.221 0 0 0 1.648-.287 3.717 3.717 0 0 0 2.365-3.583V-.005h2.508v14.476a6.161 6.161 0 0 1-3.942 5.8 6.369 6.369 0 0 1-2.58.5 6.783 6.783 0 0 1-2.652-.573 5.469 5.469 0 0 1-3.512-4.3h-.143a1.214 1.214 0 0 1-1.29-1.147 1.271 1.271 0 0 1 1.29-1.218z",
    transform: "translate(-243.793 .005)",
    style: {
      fill: "#aeaeae",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiveClubs);
export default __webpack_public_path__ + "static/media/dive-clubs.ca8710882d314a0c6f3f43cd1ca76357.svg";
export { ForwardRef as ReactComponent };